/*
 * @Name 开发环境配置项
 */
/* eslint-disable */
let wcm_domain_url = ''
var contextPath = '/'
let imageDomain = '//r-beta.hw3static.com' // 内网
imageDomain = '//r-beta.huaweistatic.com' // 外网【目前图片都存在外网】 目前uat环境的图片存在外网 其他环境存在内网,本地访问uat不显示图片时换成这个url

module.exports = {
    contextPath: contextPath,
    domainUrl: wcm_domain_url,
    imageDomain: imageDomain,
    MsaGatewayAddress: 'https://icsl-inner.test.huawei.com/eventsgo/gateway/' // icsl
}
